import Slas from './Slas'
import Show from './Show'
import SlaForm from './SlaForm'
import CompleteSla from './CompleteSla'

export default {
    Slas,
    Show,
    SlaForm,
    CompleteSla
}
